import Model from './Model'

export default class Contact extends Model
{
    static async all () {
        const params = {  };
        const { data } = await Http.get(route('api.v1.contacts.index'),{ params })
        return this.make(data)
    }

    static async forPackage (packageReference) {
        const { data } = await Http.get(route('api.v1.packages.contacts.byReference',packageReference),{ })
        return this.make(data)
    }

    static async allWithPhoneNumbers () {
        const params = { 'phone': true };
        const { data } = await Http.get(route('api.v1.contacts.index'),{ params })
        return this.make(data)
    }

    static async search (query) {
        const params = { query }
        const { data } = await Http.get(route('api.v1.contacts.search'), { params })
        return this.make(data)
    }

    static async find (id) {
        const { data } = await Http.get(route('api.v1.contacts.show', id))
        return this.make(data.data)
    }

    toDropdown() {
        const name = this.name + (  this.company ? ' ('+this.company+')' : '' )
        return { label: name, value: this.id }
    }
}
